(function () {
  function initProductList(root) {
    if (!root || root.dataset.productListInit === 'true') return;
    root.dataset.productListInit = 'true';

    var tabsWrap = root.querySelector('[data-pl-tabs]');
    var tabsIndicator = root.querySelector('[data-pl-tabs-indicator]');
    var tabsMobile = root.querySelector('[data-pl-tabs-mobile]');
    var tabsMobileScroll = root.querySelector('[data-pl-tabs-mobile-scroll]');
    var mobileTrigger = root.querySelector('[data-pl-tabs-mobile-trigger]');
    var mobileMenu = root.querySelector('[data-pl-tabs-mobile-menu]');
    var mobileLabel = root.querySelector('[data-pl-tabs-mobile-label]');
    var hasTabs = root.getAttribute('data-has-tabs') === 'true';
    var viewAllLink = root.querySelector('.product-list-showcase__view-all');
    var mobileTabsMq = window.matchMedia('(max-width: 1023px)');

    function isMobileTabs() {
      return mobileTabsMq.matches;
    }

    function updateTabsIndicator(activeBtn) {
      if (!isMobileTabs() && tabsIndicator && activeBtn && tabsWrap) {
        tabsIndicator.hidden = false;
        var wrapRect = tabsWrap.getBoundingClientRect();
        var btnRect = activeBtn.getBoundingClientRect();
        tabsIndicator.style.width = btnRect.width + 'px';
        tabsIndicator.style.left = btnRect.left - wrapRect.left + tabsWrap.scrollLeft + 'px';
      } else if (tabsIndicator) {
        tabsIndicator.hidden = true;
      }
    }

    function closeMobileMenu() {
      if (!tabsMobile || !mobileMenu || !mobileTrigger) return;
      mobileMenu.hidden = true;
      mobileTrigger.setAttribute('aria-expanded', 'false');
      tabsMobile.classList.remove('is-open');
    }

    function openMobileMenu() {
      if (!tabsMobile || !mobileMenu || !mobileTrigger) return;
      mobileMenu.hidden = false;
      mobileTrigger.setAttribute('aria-expanded', 'true');
      tabsMobile.classList.add('is-open');
    }

    function scrollMobileTabIntoView(activeBtn) {
      if (!tabsMobileScroll || !activeBtn) return;
      var maxScroll = tabsMobileScroll.scrollWidth - tabsMobileScroll.clientWidth;
      if (maxScroll <= 0) return;
      var scrollLeft = activeBtn.offsetLeft - (tabsMobileScroll.clientWidth - activeBtn.offsetWidth) / 2;
      tabsMobileScroll.scrollTo({
        left: Math.max(0, Math.min(scrollLeft, maxScroll)),
        behavior: 'smooth',
      });
    }

    function updateMobileTabs(tabId, scrollMobileTab) {
      if (!tabsMobile) return;

      if (tabsMobileScroll) {
        var activeScrollBtn = null;
        tabsMobileScroll.querySelectorAll('[data-pl-tab]').forEach(function (btn) {
          var isActive = btn.getAttribute('data-pl-tab') === tabId;
          btn.classList.toggle('is-active', isActive);
          btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
          if (isActive) activeScrollBtn = btn;
        });
        if (scrollMobileTab !== false && activeScrollBtn) scrollMobileTabIntoView(activeScrollBtn);
        return;
      }

      if (!mobileLabel) return;
      var activeLabel = '';
      tabsMobile.querySelectorAll('[data-pl-tab]').forEach(function (btn) {
        var isActive = btn.getAttribute('data-pl-tab') === tabId;
        btn.classList.toggle('is-active', isActive);
        btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
        btn.hidden = isActive;
        if (isActive) activeLabel = btn.textContent.trim();
      });
      if (activeLabel) mobileLabel.textContent = activeLabel;
      closeMobileMenu();
    }

    function resetSlideshows() {
      root.querySelectorAll('slideshow-component').forEach(function (slideshow) {
        if (typeof slideshow.select === 'function') {
          slideshow.select(0, undefined, { animate: false });
        }
      });
    }

    function enableCardGalleries() {
      root.querySelectorAll('.ps-card__slideshow').forEach(function (slideshow) {
        slideshow.removeAttribute('disabled');
      });
    }

    function switchTab(tabId, collectionUrl, options) {
      options = options || {};
      root.querySelectorAll('[data-pl-tab-item]').forEach(function (item) {
        var visible = item.getAttribute('data-pl-tab-item') === tabId;
        item.hidden = !visible;
        var slide = item.closest('slideshow-slide');
        if (slide) slide.hidden = !visible;
      });

      root.querySelectorAll('[data-pl-tab]').forEach(function (btn) {
        var isActive = btn.getAttribute('data-pl-tab') === tabId;
        btn.classList.toggle('is-active', isActive);
        btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
        if (isActive && tabsWrap && tabsWrap.contains(btn)) updateTabsIndicator(btn);
      });

      updateMobileTabs(tabId, options.scrollMobileTab);

      if (viewAllLink && collectionUrl) {
        viewAllLink.href = collectionUrl;
      }

      resetSlideshows();
      enableCardGalleries();
    }

    if (hasTabs && tabsWrap) {
      var firstTabBtn = tabsWrap.querySelector('[data-pl-tab].is-active') || tabsWrap.querySelector('[data-pl-tab]');
      if (firstTabBtn) {
        updateTabsIndicator(firstTabBtn);
      }

      tabsWrap.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-pl-tab]');
        if (!btn || btn.classList.contains('is-active')) return;
        switchTab(btn.getAttribute('data-pl-tab'), btn.getAttribute('data-collection-url'));
      });

      if (tabsMobileScroll) {
        tabsMobileScroll.addEventListener('click', function (e) {
          var btn = e.target.closest('[data-pl-tab]');
          if (!btn || btn.classList.contains('is-active')) return;
          switchTab(btn.getAttribute('data-pl-tab'), btn.getAttribute('data-collection-url'));
        });
      } else if (tabsMobile && mobileTrigger && mobileMenu) {
        mobileTrigger.addEventListener('click', function (e) {
          e.stopPropagation();
          if (tabsMobile.classList.contains('is-open')) closeMobileMenu();
          else openMobileMenu();
        });

        mobileMenu.addEventListener('click', function (e) {
          var btn = e.target.closest('[data-pl-tab]');
          if (!btn || btn.classList.contains('is-active')) return;
          switchTab(btn.getAttribute('data-pl-tab'), btn.getAttribute('data-collection-url'));
        });

        document.addEventListener('click', function (e) {
          if (!tabsMobile.contains(e.target)) closeMobileMenu();
        });

        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape') closeMobileMenu();
        });

        mobileTabsMq.addEventListener('change', function () {
          closeMobileMenu();
          var activeBtn = tabsWrap && tabsWrap.querySelector('[data-pl-tab].is-active');
          if (activeBtn) updateTabsIndicator(activeBtn);
        });
      }
    }

    root.querySelectorAll('[data-ps-swatch-media-id]').forEach(function (swatch) {
      swatch.addEventListener('mouseenter', function () {
        var card = swatch.closest('product-card');
        if (!card || typeof card.previewVariant !== 'function') return;
        var mediaId = swatch.getAttribute('data-ps-swatch-media-id');
        if (mediaId) card.previewVariant(mediaId);
      });

      swatch.addEventListener('mouseleave', function () {
        var card = swatch.closest('product-card');
        if (!card) return;
        var slideshow = card.querySelector('slideshow-component');
        if (slideshow && typeof slideshow.select === 'function') {
          slideshow.select(0, undefined, { animate: false });
        }
      });
    });

    window.addEventListener('resize', function () {
      var activeBtn = tabsWrap && tabsWrap.querySelector('[data-pl-tab].is-active');
      if (activeBtn) updateTabsIndicator(activeBtn);
      if (!isMobileTabs()) closeMobileMenu();
    });

    enableCardGalleries();
    requestAnimationFrame(enableCardGalleries);
  }

  function boot() {
    document.querySelectorAll('[data-product-list]').forEach(initProductList);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-product-list]');
    if (root) initProductList(root);
  });
})();
